<template>
    <button
        v-if="showHistoryBackButton"
        type="button"
        class="flex items-center gap-1 text-sm font-medium text-muval-gray-1 no-underline"
        @click="$emit('go-back')"
    >
        <SvgIcon
            name="system-chevron-left"
            class="size-8 md:size-5"
        />
        <span class="hidden md:block">Back</span>
    </button>
    <router-link
        v-else-if="showReturnToOrderLink"
        :to="returnToOrderRoute"
        class="flex items-center gap-1 text-sm font-medium text-muval-gray-1 no-underline"
        @click="$emit('set-active-tab')"
    >
        <SvgIcon
            name="system-chevron-left"
            class="size-8 md:size-5"
        />
        <span class="hidden md:block">Back</span>
    </router-link>
    <div class="flex w-full items-center justify-between">
        <span class="inter text-2xl font-medium">{{ headerTitle }}</span>
        <span
            v-if="orderRef"
            class="ml-4 pt-0.5 text-sm text-muval-gray-2"
            >#{{ orderRef }}</span
        >
    </div>

    <Lozenge
        v-if="orderState === 'BIN'"
        class="mt-0.5 bg-muval-gray-5 text-xs text-muval-gray-1"
        rounded
    >
        {{ capitalize(orderStatusFormatted) }}
    </Lozenge>
</template>

<script setup>
import { capitalize } from '@utilities/filters';

defineProps({
    showHistoryBackButton: {
        type: Boolean,
        default: false,
    },
    showReturnToOrderLink: {
        type: Boolean,
        default: false,
    },
    returnToOrderRoute: {
        type: Object,
        default: () => ({}),
    },
    headerTitle: {
        type: String,
        default: '',
    },
    orderRef: {
        type: [String, Number],
        default: null,
    },
    orderState: {
        type: String,
        default: null,
    },
    orderStatusFormatted: {
        type: String,
        default: null,
    },
});

defineEmits(['go-back', 'set-active-tab']);
</script>
